import FavPanelComponent from './FavPanel'
import FavPanelView from './FavPanelView'


export default FavPanelComponent
export { FavPanelView }
